(function filmStrip(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.FullImageViewerState ||
    !global.NewHomeSource.Event ||
    !global.NewHomeSource.VerticalSwiper ||
    !global.NewHomeSource.FullImageViewer.Config ||
    !global.NewHomeSource.Modules.ImageHandler) {
    return;
  }

  const previousFilmStrip = global.NewHomeSource.FilmStrip;
  const activeCssClass = 'active';
  const filmStripSelector = '[data-full-image-viewer-role="filmstrip"]';
  const queryfullImageRoleThumbnail = '[data-full-image-viewer-role="thumbnail"]';
  const queryUpElement = '[data-full-image-viewer-role="up"]';
  const queryDownElement = '[data-full-image-viewer-role="down"]';
  const thumbsVisible = 'thumbs--visible';
  const thumbsHidden = 'thumbs--hidden';
  const containerElement = global.document.querySelector(filmStripSelector);
  const parentElement = global.document.querySelector('[data-full-image-viewer-role="filmstrip-parent"]');
  const params = 'w=112&h=82&mode=crop';
  const downElement = global.document.querySelector(queryDownElement);
  const upElement = global.document.querySelector(queryUpElement);
  const eventToAttach = global.NewHomeSource.FullImageViewer.Config.getClickOrTouchEvent();
  const fullImageViewer = global.NewHomeSource.FullImageViewer.Config.fullImageViewer;
  const step = 86;
  const hidden = 'hidden';
  let translationInY = 0;
  let swiper;

  /**
 * @private
 * getSrc: creates a thumbnail that can be added to the film strip.
 * @param {object} data information that is going to be used to create the thumbnail.
 */
  function getSrc(data) {
    if (!data.ThumbnailUrl) {
      return null;
    }

    let url = data.ThumbnailUrl;

    if (data.VideoType === 'vimeo') {
      url = data.ThumbnailUrl.replace('_640.jpg', '_150.jpg');
    } else if (data.VideoType !== 'youtube') {
      url = global.NewHomeSource.Modules.ImageHandler.addJpgParameter(data.ThumbnailUrl, params);
    }

    return url;
  }

  /**
   * @private
   * createThumbnail: creates a thumbnail that can be added to the film strip.
   * @param {object} data information that is going to be used to create the thumbnail.
   */
  function createThumbnail(data) {
    const button = global.document.createElement('BUTTON');
    const image = global.document.createElement('IMG');
    const src = getSrc(data);

    if (!src) {
      return null;
    }

    button.classList.add('thumbs__btn');
    button.setAttribute('data-full-image-viewer-role', 'thumbnail');
    button.setAttribute('data-description', data.Title);
    button.id = 'Image' + data.Id;
    image.src = src;
    image.alt = data.Alt;
    image.classList.add('thumbs__img');
    button.appendChild(image);

    return button;
  }

  /**
   * @private
   * updateTranslation: updates the translateY position of the film strip container.
   */
  function updateTranslation(translateToSelectedElement) {
    containerElement.style.height = 'auto';
    translationInY = parseInt(translationInY / step, 10) * step;
    const selectedElement = document.querySelector(queryfullImageRoleThumbnail + '.' + activeCssClass);
    const selectedTop = selectedElement ? selectedElement.offsetTop : 0;
    const availableHeight = parentElement.getBoundingClientRect().height - step;
    const totalHeight = containerElement.getBoundingClientRect().height - step;
    const maxMovement = availableHeight - totalHeight;
    let movement = translationInY + step * this.direction;

    translationInY = movement;

    if (translateToSelectedElement === true) {
      movement = -selectedTop;
      translationInY = -selectedTop;
    }

    if (movement >= 0) {
      movement = 0;
      upElement.setAttribute(hidden, true);
    } else if (translationInY < 0) {
      upElement.removeAttribute(hidden);
    }

    if (movement - (step / 2) <= maxMovement) {
      movement = maxMovement;
      downElement.setAttribute(hidden, true);
    } else if (totalHeight > availableHeight) {
      downElement.removeAttribute(hidden);
    }

    if (maxMovement > 0) {
      movement = 0;
      downElement.setAttribute(hidden, true);
      upElement.setAttribute(hidden, true);
      containerElement.style.height = '100%';
    }

    containerElement.style.transitionDuration = '0.3s';
    containerElement.style.transform = 'translateY(' + movement + 'px)';

    if (swiper) {
      swiper.update(movement);
    }
    global.NewHomeSource.FullImageViewer.Config.fullImageViewer.focus();
  }

  /**
   * @private
   * validate: hides or displays the up and down arrows.
   *
   * @param {number} value relative position.
   */
  function validate(value) {
    const availableHeight = parentElement.getBoundingClientRect().height;
    const totalHeight = containerElement.getBoundingClientRect().height - step;
    const maximum = availableHeight - totalHeight;
    translationInY = value;
    fullImageViewer.focus();

    if (value === 0) {
      upElement.setAttribute(hidden, true);
      requestAnimationFrame(updateTranslation.bind({ direction: 0 }, false));
      return;
    }
    upElement.removeAttribute(hidden);
    if (value < maximum) {
      downElement.setAttribute(hidden, true);
    } else {
      downElement.removeAttribute(hidden);
    }
  }

  /**
   * @private
   * render: renders the film strip.
   *
   * @param {object} data information that is needed to render the film strip.
   */
  function render(data) {
    const documentFragment = document.createDocumentFragment();
    const collectionImages = data.Images;
    const imageKeys = Object.keys(collectionImages);
    const imageKeysLength = imageKeys.length;
    const filler = global.document.createElement('DIV');
    const visibilityClass = global.NewHomeSource.FullImageViewer.Config.isFilmStripVisible(data)
      ? thumbsVisible
      : thumbsHidden;

    translationInY = 0;
    containerElement.style.transform = 'translateY(' + translationInY + 'px)';
    containerElement.parentElement.classList.remove(thumbsVisible);
    containerElement.parentElement.classList.remove(thumbsHidden);
    containerElement.parentElement.classList.add(visibilityClass);
    filler.classList.add('thumbs__filler');

    for (let current = 0; current < imageKeysLength; current += 1) {
      const currentImage = collectionImages[imageKeys[current]];
      const thumbnail = createThumbnail(currentImage);

      if (thumbnail) {
        documentFragment.appendChild(thumbnail);
      }
    }

    containerElement.innerHTML = '';
    containerElement.appendChild(documentFragment);
    containerElement.appendChild(filler);
    requestAnimationFrame(updateTranslation.bind({ direction: 0 }, true));
  }

  /**
   * @private
   * renderActiveThumbnail: renders the active thumbnail.
   * @param {object} data information that is needed to set the active thumbnail.
   */
  function renderActiveThumbnail(data) {
    const activeThumbnail = global.document
      .querySelector(queryfullImageRoleThumbnail + '.' + activeCssClass);
    const newActiveThumbnail = global.document
      .querySelector(queryfullImageRoleThumbnail + '#Image' + data.Id);

    if (activeThumbnail) {
      activeThumbnail.classList.remove(activeCssClass);
    }

    if (newActiveThumbnail) {
      newActiveThumbnail.classList.add(activeCssClass);
    } else {
      const allThumbnails = global.document.querySelectorAll(queryfullImageRoleThumbnail);

      if (allThumbnails.length > 0) {
        allThumbnails[allThumbnails.length - 1].classList.add(activeCssClass);
      }
    }
  }

  /**
   * @private
   * findById: returns true if the item Id is equals to the binded Id, otherwise false.
   */
  function findById(item) {
    return item.Id === this.id;
  }

  /**
   * @private
   * setImage: set the image pressed by the user as the new selected image.
   */
  function setImage(event) {
    const trigger = event.target.closest(queryfullImageRoleThumbnail);

    if (!trigger) {
      return;
    }

    const triggerId = +trigger.id.replace('Image', '');
    const state = global.NewHomeSource.FullImageViewerState.get();
    const newImage = state.images.find(findById, { id: triggerId });

    global.NewHomeSource.FullImageViewerState.setImage(newImage);
  }

  /**
   * @private
   * validateWheel: move the filmstrip with the mouse wheel.
   */
  function validateWheel(scrollValue) {
    let value = 0;
    fullImageViewer.focus();
    if (scrollValue > 0) {
      value = -1;
    } else if (scrollValue < 0) {
      value = 1;
    }
    requestAnimationFrame(updateTranslation.bind({ direction: value }));
  }

  /**
   * @private
   * setupSwiper: attaches listeners to handle swiping actions.
   */
  function setupSwiper() {
    swiper = new global.NewHomeSource.VerticalSwiper(containerElement, validate, parentElement, validateWheel);
  }

  const events = {
    click: {
      callbacks: [setImage],
      elements: filmStripSelector,
      events: [eventToAttach],
    },
  };

  /**
  * @constructs NewHomeSource.FilmStrip
  */
  function FilmStrip() {
  }

  /**
   * @public
   * update: this method will be called by the Event Bus when the data is updated.
   *
   * @param {object} data information that was changed.
   * @param {string} topic that was triggered by the Event Bus.
   */
  FilmStrip.update = function update(data, topic) {
    if (topic === 'onCollectionSet') {
      requestAnimationFrame(render.bind(this, data, topic));
    }

    if (topic === 'onImageSet') {
      requestAnimationFrame(renderActiveThumbnail.bind(this, data));
    }

    if (topic === 'onResize') {
      requestAnimationFrame(updateTranslation.bind({ direction: 0 }, false));
    }
  };

  /**
   * @public
   * move: translates the filmStrip content down by moving the Y axis in negative steps.
   */
  FilmStrip.move = function move(event) {
    const trigger = event.target.closest('[data-full-image-viewer-role]');
    let value = 0;

    if (trigger.getAttribute('data-full-image-viewer-role') === 'down' ||
      trigger.getAttribute('data-full-image-viewer-role') === 'right') {
      value = -1;
    } else if (trigger.getAttribute('data-full-image-viewer-role') === 'up' ||
      trigger.getAttribute('data-full-image-viewer-role') === 'left') {
      value = 1;
    }

    if (value) {
      requestAnimationFrame(updateTranslation.bind({ direction: value }, true));
    }
  };

  /**
   * @public
   * moveArrow: translates the filmStrip content down by key down.
   */
  FilmStrip.moveArrow = function moveArrow(event) {
    let value = 0;
    if (event.keyCode === 37 || event.keyCode === 38) {
      value = 1;
    } else if (event.keyCode === 39 || event.keyCode === 40) {
      value = -1;
    }

    requestAnimationFrame(updateTranslation.bind({ direction: value }, true));
  };

  /**
  * @public
  *
  * noConflict: Returns control of NewHomeSource.FilmStrip to the previous script.
  */
  FilmStrip.noConflict = function noConflict() {
    global.NewHomeSource.FilmStrip = previousFilmStrip;
    return FilmStrip;
  };

  requestAnimationFrame(setupSwiper);
  global.NewHomeSource.Event(events);
  global.NewHomeSource.FullImageViewerState.add('onCollectionSet', FilmStrip);
  global.NewHomeSource.FullImageViewerState.add('onImageSet', FilmStrip);
  global.NewHomeSource.FullImageViewerState.add('onResize', FilmStrip);
  global.NewHomeSource.FilmStrip = FilmStrip;
}(window));
